const taskTemplates = require('../../task-templates');

const tasksData = [
	/* Case 1 */
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'education-input-stx',
		text: `STX er en forkortelse – hvad står bogstaverne for?`,
		hintText: `Det kan googles ret hurtigt.`,
		popupText: `STX er en af de mest populære ungdomsuddannelser i Danmark og har eksisteret i mere end 100 år.`,
		answer: 'Studentereksamen',
		altAnswers: ['Studenter eksamen', 'Student eksamen'],
		subtype: 'string',
		unit: null,
		image: 'stx-hat'
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'education-mc-stx-duration',
		text: `Hvor mange år kan en STX-uddannelse vare?`,
		hintText: `I kan finde svaret her: 
			<br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser`,
		popupText: `En gymnasieuddannelse er bygget op, så man både når at have grundforløb og fordybelse i fagene.`,
		image: 'stx-classroom-female-student',
		shuffleOptions: false,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: '1 år'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: '2 år', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: '3 år', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: '4 år'
			})
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 3,
		subtype: 'images',
		title: 'Opgave 3',
		taskId: 'education-mc-cool-school-items',
		text: `I skal i skole på det seje gymnasium! Hvilket udstyr tror I, I skal have med for at være klar til en dag med fag og projekter?`,
		hintText: `Det handler om ting, man bruger hver dag i undervisningen.`,
		popupText: `Gymnasiet handler ikke kun om bøger – gruppearbejde, teknologi og fælles projekter fylder også meget.`,
		layout: 'stx-cool-school-items',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'laptop', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'books', isCorrect: true
			}),
			// Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
			// 	id: 'group-work', isCorrect: true
			// }),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'phone'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'money',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'smartboard', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'chefs-hat',
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 4,
		title: 'Opgave 4',
		taskId: 'education-mc-stx-students',
		text: `Hvor mange elever tror I, der cirka starter på STX hvert år i Danmark?`,
		hintText: `Der er ca. 150 STX-gymnasier i Danmark. Tænk over, hvor mange elever der typisk starter på hvert gymnasium hvert år.`,
		popupText: `STX er den største ungdomsuddannelse i Danmark.`,
		image: 'stx-graduation-throw-hats',
		shuffleOptions: false,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Ca. 5.000'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Ca. 10.000',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Ca. 20.000'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Ca. 30.000', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'Ca. 40.000'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6, text: 'Ingen ved det, men alle taler om det'
			})
		],
	}),
	/* Case 2 */
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'education-mc-3-characteristics',
		text: `Hvilke tre ting tror I, bedst beskriver elever, der vælger STX?`,
		hintText: `I kan finde svaret her: 
			<br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/almen-studentereksamen-stx`,
		popupText: `STX tiltrækker mange forskellige typer – men fælles er, at de fleste godt kan lide at kombinere fag fra både sprog, kultur og naturvidenskab.`,
		image: 'stx-male-student',
		shuffleOptions: false,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'De vil gerne vil lære om sprog, kultur, naturvidenskab og samfund', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'De foretrækker praktisk arbejde og laberatorie samt værkstedsopgaver',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'De kan lide undervisning, der er mere teoretisk end praktisk', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'De trives bedst med korte lektioner og få hjemmearbejdsopgaver'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'De er klar over, at uddannelse kræver forberedelse og lektier i fritiden', isCorrect: true
			})
		],
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 2,
		taskId: 'education-sort-basic',
		title: 'Opgave 2',
		text: `Grundforløb på STX – hvad hører med?
			<br /><br />I er nye på STX og skal finde ud af, hvad der sker i grundforløbet. Kan I sortere det, der hører med, fra det, der ikke gør?`,
		hintText: `Det står på UddannelsesGuiden.`,
		popupText: `Grundforløbet er den første tid på gymnasiet, hvor alle prøver fag og studieretninger, før man vælger sin endelige retning.`,
		layout: 'education-sort-basic',
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'true', title: `Sandt om grundforløbet`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'false', title: `Falsk om grundforløbet`})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Introduktion til fag og studieretninger`, categoryIds: ['true']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `De første 3 måneder på STX er grundforløb`, categoryIds: ['true']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Alle på en skole har de samme fag på grundforløbet`, categoryIds: ['true']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Man får indblik i videregående uddannelser`, categoryIds: ['true']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Introduktion til alle gymnasiets undervisere og vejledere`, categoryIds: ['false']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Grundforløbet starter allerede efter de første 3 måneder`, categoryIds: ['false']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 7, text: `Man vælger selv, hvilke fag man skal have på grundforløbet`, categoryIds: ['false']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 8, text: `Under grundforløbet skal man besøge videregående uddannelser`, categoryIds: ['false']}),
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 3,
		taskId: 'education-order-visit',
		title: 'Opgave 3',
		text: `I dag handler det om %school%. Hvad tror I, er de bedste ting at gøre, hvis %school% virker spændende? Sæt dem i den rækkefølge, I synes giver mest mening.`,
		hintText: `Det er i hvert falde en god ide at besøge et åbent hus.`,
		popupText: `Mange elever finder først ud af, om STX er noget for dem, når de har været til åbent hus.`,
		layout: 'halfdouble-height',
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Prøve kræfter med %school%s STX spil`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Skrive sig op til åbent hus direkte i spillet, når det er færdigt`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Læse mere på uddannelsesguiden - www.ug.dk`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Tale med sin vejleder og lærere`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Tage mor og far med til åbent hus`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `Beslutte sig i god tid og ansøge`, correctOrderNumbers: [6]
			})
		]
	}),
	/* Case 3 */
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 1,
		taskId: 'education-order-university-job',
		title: 'Opgave 1',
		text: `Hvad tror I er rækkefølgen for en gymnasieelev, der drømmer om et job med en universitetsuddannelse? Sæt trinnene i rigtig rækkefølge – fra start til slut.`,
		hintText: `Start med skolen og slut med jobbet.`,
		popupText: `Det kan tage mange år fra man starter på gymnasiet, til man står færdig som fx læge eller jurist – men gymnasiet er et godt sted at begynde.`,
		layout: 'halfdouble-height',
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Færdiggøre grundskolen`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Begynde på gymnasiet`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Vælge studieretning og fagpakke`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Gennemføre gymnasieeksamen`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Fuldføre videregående uddannelse`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `Starte i job`, correctOrderNumbers: [6]
			})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 2,
		taskId: 'education-sort-dreams',
		title: 'Opgave 2A',
		text: `Hvilke jobs og karrierer tror I, mange STX-elever går og drømmer om?`,
		hintText: `ChatGPT kan hjælpe jer godt på vej.`,
		popupText: `Mange STX-elever drømmer om job, hvor man arbejder med mennesker, samfund eller videnskab – fx inden for sundhed, jura eller kultur.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'typical', title: `Typiske drømme`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'notTypical', title: `Ikke typiske drømme`})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Læge`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `Ingeniør`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Advokat`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Journalist`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Lærer`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Arkitekt`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 7, text: `Psykolog`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 8, text: `Forsker`, categoryIds: ['typical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 9, text: `Frisør`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 10, text: `Programmør`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 11, text: `Revisor`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 12, text: `Marketingchef`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 13, text: `Økonom`, categoryIds: ['notTypical']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 14, text: `Salgsdirektør`, categoryIds: ['notTypical']}),
		]
	}),
	Object.assign({}, taskTemplates.paperDollTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 3,
		title: 'Opgave 2B',
		taskId: 'education-paper-doll-doctor',
		lockedById: 'education-sort-dreams',
		layout: 'education-doctor',
		avatarId: 'avatar-1',
		text: `Et af jobbene, vi nævnte, var læge. Hvilket udstyr tror I, man bruger som læge? Vælg de ting, der passer bedst – og klik OK, når I synes, I har ramt rigtigt.`,
		hintText: `Tænk på, hvad en læge bruger i hverdagen.`,
		items: [
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'syringe-b', title: 'Sprøjte med nål', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'lab-coat-white', title: 'Hvid kittel', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'chart', title: 'Notatblok til journalføring', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'camera-b', title: 'Kamera'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'paint-brush', title: 'Malerpensel'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'safety-shoes', title: 'Sikkerhedssko'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'stethoscope', title: 'Stetoskop', isCorrect: true
			})
		]
	}),
	Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 4,
		title: 'Opgave 3',
		taskId: 'education-spot-errors-job-event',
		layout: 'education-job-event',
		text: `Mange gymnasieelever tager til jobmesser og karriereevents. På billedet ser I en elev til en jobmesse – men der er nogle ting, der ikke helt passer. Kan I finde dem? Klik OK, når I tror, I har alle.`,
		hintText: `Kig på ting, der virker forkerte i et professionelt møde.`,
		errors: [
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'tie'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'lamp'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'chair'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'paper'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'cup'})
		]
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 5,
		title: 'Opgave 4',
		taskId: 'education-input-limits',
		text: `Hvis man vælger STX, sætter det så grænser for, hvad man kan blive i fremtiden?`,
		hintText: `Gå med jeres fornemmelse.`,
		popupText: `I Danmark har man altid mulighed for at skifte retning efter sin ungdomsuddannelse. Hvis der mangler fag til en bestemt videregående uddannelse, kan man supplere med enkeltfag og tilpasse sin vej undervejs. `,
		answer: 'Nej',
		subtype: 'string',
		unit: null
	}),
];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
	/* Assign unique id used for navigation */
	task.id = 'stxhf-edu-' + (index + 1 < 10 ? '0' : '') + (index + 1);

	/* Check taskId is set when required and unique */
	if (task.taskId) {
		if (taskIdsArr.indexOf(task.taskId) >= 0) {
			console.error('Task id not unique: ', task.taskId);
		} else {
			taskIdsArr.push(task.taskId);
		}
	} else {
		console.error('Missing task id for task: ', task);
	}
});

export {
	tasksData
};